import SearchContext from 'contexts/SearchContext';
import React, { useContext, useEffect, useState } from 'react';
import { X } from 'react-feather';

import Button from '../../buttons/Button';
import IconButton from '../../buttons/IconButton';
import { generateContextFilters, generateOptions, isArrayEqual, twoCols } from './common';
import FilterOption from './FilterOption';
import { Mixpanel } from 'utils/Mixpanel';
import { setFilters, setPage } from 'contexts/SearchActions';

function MobileSearchFilters({ handleClose }) {
    const { state, dispatch } = useContext(SearchContext);
    const [selectedFilters, setSelectedFilters] = useState([]);

    useEffect(() => {
        setSelectedFilters(state.filters);
    }, [state.filters]);

    const handleOptionChange = (isChecked, option) => {
        if (isChecked) {
            setSelectedFilters((existingFilters) => [...existingFilters, option]);
        } else {
            setSelectedFilters((existingFilters) => [...existingFilters.filter((opt) => opt.value !== option.value)]);
        }
    };

    // Commit selected filters
    const handleSubmit = () => {
        if (isArrayEqual(selectedFilters, state.filters)) handleClose();
        setPage(dispatch, 1);
        setFilters(dispatch, generateContextFilters(selectedFilters));
        handleClose();
    };

    useEffect(() => {
        if (selectedFilters.length > 0) {
            Mixpanel.track('Search filters', {
                filters: selectedFilters.map((f) => f.value),
                mobile: true,
                view: state.mapView ? 'list' : 'map'
            });
        }
    }, [selectedFilters]);

    return (
        <div className="flex h-full flex-col justify-between">
            <div className="py-2 pl-4 pr-2 border-b border-gray-200 flex justify-between items-center text-center">
                <h4>Filtriraj</h4>
                <IconButton onClick={handleClose}>
                    <X />
                </IconButton>
            </div>
            <div className="p-6 space-y-8 flex-grow overflow-y-auto">
                {state.availableFilters.map((filter, i) => (
                    <div key={i}>
                        <h5>{filter.name}</h5>
                        <div
                            className={`relative mt-3 grid gap-4  ${
                                twoCols.includes(filter.slug) ? 'grid-cols-2' : ''
                            }`}
                        >
                            {generateOptions(filter).map((option, i) => (
                                <FilterOption
                                    key={i}
                                    label={option.label}
                                    filterSlug={filter.slug}
                                    onChange={(isChecked) => handleOptionChange(isChecked, option)}
                                    checked={
                                        selectedFilters.find(
                                            (opt) => filter.slug === opt.slug && opt.value === option.value
                                        ) || false
                                    }
                                />
                            ))}
                        </div>
                    </div>
                ))}
            </div>
            <div className="py-4 px-4 mt-4 border-t border-gray-200 flex justify-between">
                <Button variant="text" color="secondary" onClick={() => setSelectedFilters([])}>
                    Ponastavi
                </Button>
                <Button variant="contained" color="secondary" onClick={handleSubmit}>
                    Prikaži rezultate
                </Button>
            </div>
        </div>
    );
}

export default MobileSearchFilters;
